export default __webpack_public_path__ + "static/media/backArrowBlack.52af840d.svg";